import React from 'react';
import { Text as RNText, FlatList } from 'react-native';
import { Focusable } from '../../Focusable';
import { useStyleSheet } from '../../../hooks';
import { createStyleSheet } from '../../../utils';
const options = [
    '12',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11'
]
    .flatMap((hour) => ['00', '15', '30', '45'].map((minute) => `${hour}:${minute}`))
    .reduce((acc, v) => [
    [...acc[0], `${v}am`],
    [...acc[1], `${v}pm`]
], [[], []])
    .flat();
export const Picker = React.forwardRef(({ style, onSelect }, ref) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(FlatList, { ref: ref, 
        // showsVerticalScrollIndicator={false}
        style: [styles.container, style], contentContainerStyle: styles.contentContainer, data: options, keyExtractor: (item) => item, renderItem: ({ item }) => (React.createElement(Focusable, { onPress: () => {
                onSelect(item);
            }, style: styles.item, hoverStyle: styles.hoveredItem },
            React.createElement(RNText, { style: styles.text }, item))) }));
});
Picker.displayName = 'Picker';
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        height: size.M * 4.5,
        width: size.P + size.D + 2 * size.G,
        backgroundColor: color.bg.v3,
        borderRadius: size.G,
        left: -size.G,
        zIndex: 9
    },
    contentContainer: {
        padding: size.B
    },
    text: {
        fontSize: size.F,
        lineHeight: size.H,
        letterSpacing: -0.01,
        fontWeight: '500',
        color: color.invert2.p100
    },
    item: {
        padding: size.E,
        borderRadius: size.D
    },
    hoveredItem: {
        backgroundColor: color.invert2.p10
    }
}));
//# sourceMappingURL=Picker.js.map